import isEmpty from 'lodash-es/isEmpty'
import pick from 'lodash-es/pick'
import startCase from 'lodash-es/startCase'
import routes from 'config/routes'
import { useNetwork } from '~/networkProvider'
import { useNavigate } from 'react-router-dom'
import { Button } from '~/ui/Button'
import { UtilityBox } from '~/store/objects/types'

const TYPES = ['controlPanel', 'electricPanel'] as const

const FIELDS = {
  controlPanel: ['type', 'fans'],
  electricPanel: ['voltage', 'brand'],
} as const

export const isComplete = (val: unknown) => {
  if (Array.isArray(val) && val.length === 0) return false
  return val !== 0 && val !== null && val !== undefined && val !== ''
}

type AddInstallInfoButtonProps = {
  type: UtilityBox['utilityBoxType']
  disabled?: boolean
  selectedObject: { id: string }
}

function AddInstallInfoButton({ disabled, type, selectedObject }: AddInstallInfoButtonProps) {
  const { online } = useNetwork()
  const navigate = useNavigate()
  const modalKey = `add${startCase(type).replace(' ', '')}InstallInfo` as keyof typeof routes.modals
  const currentTypeFields = pick(selectedObject, FIELDS[type as keyof typeof FIELDS])
  const isRequiredType = TYPES.includes(type as keyof typeof FIELDS)
  const hasSavedData = !isEmpty(currentTypeFields) && Object.values(currentTypeFields).every(isComplete)

  const label = () => {
    if (hasSavedData && online) {
      return 'Update'
    }
    if (hasSavedData && !online) {
      return 'View'
    } else {
      return 'Add'
    }
  }
  return isRequiredType && online ? (
    <Button
      isDisabled={disabled}
      onClick={() => navigate(`.${routes.modals[modalKey]}?objectId=${selectedObject.id}`, { relative: 'path' })}
    >
      {label()} install information
    </Button>
  ) : null
}

export default AddInstallInfoButton
